import * as requestFromServer from "./crud";
import {samplesSlice, callTypes} from "./slices";
import {convertFilter} from "../../../utils/commonUtils";

const {actions} = samplesSlice;

export const fetchSamples = queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.list}));

  const _filter = convertFilter(queryParams);

  return requestFromServer
    .getSamplesByFilter(_filter)
    .then(response => {
      const {pageInfo: {totalCnt}, reqSampleList} = response;
      dispatch(actions.samplesFetched({totalCnt, reqSampleList}));
    })
    .catch(error => {
      error.clientMessage = "Can't find links";
      dispatch(actions.catchError({error, callType: callTypes.list}));
    });
};

export const fetchSample = id => dispatch => {
  if (!id) {
    return dispatch(actions.linkFetched({link: undefined}));
  }
  dispatch(actions.startCall({callType: callTypes.action}));
  return requestFromServer
    .getSampleById(id)
    .then(response => {
      const sample = response;
      dispatch(actions.sampleFetched({sample}));
    })
    .catch(error => {
      console.log(error);
      error.clientMessage = "Can't find link";
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};
